import { registerPlugin } from '@capacitor/core';

import type { MoECapacitorGeofencePlugin } from './definitions';

const MoECapacitorGeofence = registerPlugin<MoECapacitorGeofencePlugin>('MoECapacitorGeofence', {});

export * from './definitions';
export { MoECapacitorGeofence };
